var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pz-form-flujo",
    {
      attrs: {
        "available-captcha": _vm.extraData.withCaptcha,
        forward: _vm.handleSave,
        backwards: _vm.showBack ? _vm.handleBack : null
      },
      model: {
        value: _vm.formulario2["captcha"],
        callback: function($$v) {
          _vm.$set(_vm.formulario2, "captcha", $$v)
        },
        expression: "formulario2['captcha']"
      }
    },
    [
      _c("span", { attrs: { slot: "form_title" }, slot: "form_title" }, [
        _vm._v(" " + _vm._s(_vm.$t("forms_flujo.form2_persona.UY.title")) + " ")
      ]),
      _c(
        "el-form",
        {
          ref: _vm.reference,
          attrs: {
            slot: "formulario",
            "label-position": "top",
            model: _vm.formulario2,
            "status-icon": "",
            rules: _vm.rules_formulario2
          },
          slot: "formulario"
        },
        [
          _c("pz-direction", {
            attrs: { viewline: "" },
            model: {
              value: _vm.formulario2.direccion,
              callback: function($$v) {
                _vm.$set(_vm.formulario2, "direccion", $$v)
              },
              expression: "formulario2.direccion"
            }
          }),
          _c("label", [
            _vm._v(
              _vm._s(_vm.$t("forms_flujo.form2_persona.BNF.datos_particulares"))
            )
          ]),
          _c("hr", {
            staticClass: "pz-dotted",
            staticStyle: { "margin-top": "1px" }
          }),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "genero",
                        label: _vm.$t("forms_flujo.form1_persona.SP.genero"),
                        error: _vm.errors.get("genero")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "genero",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t(
                              "forms_flujo.form1_persona.SP.genero"
                            )
                          },
                          model: {
                            value: _vm.formulario2.genero,
                            callback: function($$v) {
                              _vm.$set(_vm.formulario2, "genero", $$v)
                            },
                            expression: "formulario2.genero"
                          }
                        },
                        _vm._l(_vm.genero, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name,
                              value: item.id,
                              placeholder: _vm.$t(
                                "forms_flujo.form1_persona.SP.genero"
                              )
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "estado_civil_id",
                        label: _vm.$t(
                          "forms_flujo.form1_persona.UY.civil_state"
                        ),
                        error: _vm.errors.get("estado_civil_id")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "estado_civil_id",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t(
                              "forms_flujo.form1_persona.UY.civil_state"
                            )
                          },
                          model: {
                            value: _vm.formulario2.estado_civil_id,
                            callback: function($$v) {
                              _vm.$set(_vm.formulario2, "estado_civil_id", $$v)
                            },
                            expression: "formulario2.estado_civil_id"
                          }
                        },
                        _vm._l(_vm.marital_status, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.estado,
                              value: item.id,
                              placeholder: _vm.$t(
                                "forms_flujo.form1_persona.UY.civil_state"
                              )
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "pais_nacimiento",
                        label: _vm.$t(
                          "forms_flujo.form1_persona.SP.nacionalidad"
                        )
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "pais_nacimiento",
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: _vm.$t(
                              "forms_flujo.form1_persona.SP.nacionalidad"
                            )
                          },
                          model: {
                            value: _vm.formulario2.pais_nacimiento,
                            callback: function($$v) {
                              _vm.$set(_vm.formulario2, "pais_nacimiento", $$v)
                            },
                            expression: "formulario2.pais_nacimiento"
                          }
                        },
                        _vm._l(_vm.paises, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.nacionalidad,
                              value: item.id,
                              placeholder: _vm.$t(
                                "forms_flujo.form1_persona.SP.nacionalidad"
                              )
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "telefono_fijo",
                        label: _vm.$t("forms_flujo.form2_persona.UY.phone"),
                        error: _vm.errors.get("telefono_fijo")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "no",
                          placeholder: _vm.$t(
                            "forms_flujo.form2_persona.UY.phone"
                          )
                        },
                        model: {
                          value: _vm.formulario2.telefono_fijo,
                          callback: function($$v) {
                            _vm.$set(_vm.formulario2, "telefono_fijo", $$v)
                          },
                          expression: "formulario2.telefono_fijo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "email",
                        label: _vm.$t("forms_flujo.form2_persona.UY.email"),
                        error: _vm.errors.get("email")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "no",
                          placeholder: _vm.$t(
                            "forms_flujo.form2_persona.UY.email"
                          )
                        },
                        model: {
                          value: _vm.formulario2.email,
                          callback: function($$v) {
                            _vm.$set(_vm.formulario2, "email", $$v)
                          },
                          expression: "formulario2.email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "sucursal_id",
                        label: _vm.$t(
                          "forms_flujo.form1_persona.UY.sucursales"
                        ),
                        error: _vm.errors.get("sucursal_id")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "sucursal_id",
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t(
                              "forms_flujo.form1_persona.UY.sucursales"
                            )
                          },
                          model: {
                            value: _vm.formulario2.sucursal_id,
                            callback: function($$v) {
                              _vm.$set(_vm.formulario2, "sucursal_id", $$v)
                            },
                            expression: "formulario2.sucursal_id"
                          }
                        },
                        _vm._l(_vm.sucursales, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.name,
                              value: item.id,
                              placeholder: _vm.$t(
                                "forms_flujo.form1_persona.UY.sucursales"
                              )
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("label", [
            _vm._v(
              _vm._s(_vm.$t("forms_flujo.form2_persona.BNF.datos_conyugue"))
            )
          ]),
          _c("hr", {
            staticClass: "pz-dotted",
            staticStyle: { "margin-top": "1px" }
          }),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "nombre_conyuge",
                        label: _vm.$t(
                          "forms_flujo.form2_persona.BNF.nombre_conyuge"
                        ),
                        error: _vm.errors.get("nombre_conyuge")
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "nombre_conyuge",
                        attrs: {
                          type: "text",
                          placeholder: _vm.$t(
                            "forms_flujo.form2_persona.BNF.nombre_conyuge"
                          )
                        },
                        model: {
                          value: _vm.formulario2.nombre_conyuge,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formulario2,
                              "nombre_conyuge",
                              _vm._n($$v)
                            )
                          },
                          expression: "formulario2.nombre_conyuge"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                {
                  attrs: {
                    xl: { span: 12 },
                    lg: { span: 12 },
                    md: { span: 12 },
                    sm: { span: 24 },
                    xs: { span: 24 }
                  }
                },
                [
                  _c("pz-identity-document", {
                    attrs: {
                      prop: "cedula_conyuge",
                      type: "person",
                      "type-label": _vm.$t(
                        "forms_flujo.form1_persona.UY.tipo_doc"
                      ),
                      "number-label": _vm.$t(
                        "forms_flujo.form1_persona.UY.identity_doc"
                      )
                    },
                    model: {
                      value: _vm.formulario2.cedula_conyuge,
                      callback: function($$v) {
                        _vm.$set(_vm.formulario2, "cedula_conyuge", $$v)
                      },
                      expression: "formulario2.cedula_conyuge"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }